import { Command } from 'cmdk';

const CommandMenuGroup = Command.Group;

export default CommandMenuGroup;
